import { gql } from '@apollo/client';

export const mutation = gql`
  mutation InsertTag($label: String!, $type: tag_types_enum!) {
    insert_tags_one(object: { label: $label, type: $type }) {
      id
      label
      type
    }
  }
`;

export function buildVariables({ label, type }) {
  return { label, type };
}
